import { rem } from "@/styles/utils"
import { device_px } from "@/styles/variable"
import styled from "styled-components"

const { MAX_767, MAX_1279, MAX_1439, MAX_1919 } = device_px

export const SessionTracksContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  gap: 14px;
  margin-top: ${rem(40)};
  @media screen and (max-width: ${MAX_1919}) {
    display: flex;
    margin-top: ${rem(40)};
  }
  @media screen and (max-width: ${MAX_1439}) {
    display: flex;
    margin-top: ${rem(40)};
  }
  @media screen and (max-width: ${MAX_1279}) {
    display: flex;
    margin-top: ${rem(30)};
  }
  @media screen and (max-width: ${MAX_767}) {
    display: flex;
    min-width: 290px;
    margin-top: ${rem(30)};
  }
`
export const SessionTrackList = styled.div`
  width: 100%;
  max-height: 69px;
  display: flex;
  overflow: hidden;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  align-self: stretch;
  -webkit-transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
  -moz-transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
  -o-transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
  transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
  div {
    display: flex;
    padding: 5px 18px;
    justify-content: center;
    align-items: center;
  }
  &.show {
    max-height: 500px;
    overflow: auto;
    transition: max-height 1s ease-in-out;
  }
  &::-webkit-scrollbar {
    display: none;
  }
`

export const IconAction = styled.button`
  position: absolute;
  right: 0;
  bottom: 10px;
  background-color: transparent;
  border: none;
  outline: none;
  transition: transform 0.5s cubic-bezier(0, 1, 0, 1);
  svg {
    &.rotate {
      transform: rotate(180deg);
    }
  }
`
